import React, { useState, useEffect } from "react";
import './Stock.css';

function Stock() {
  const [stock, setStock] = useState([]);

  useEffect(() => {
    fetch("/products.json")
      .then((response) => response.json())
      .then((data) => setStock(data));
  }, []);

  return (
    <div className="stock-container">
      <h1 className="stock-title">Envios a todo Mexico</h1>

      <section className="stock-section">
        <h2 className="stock-heading">Stock Disponible</h2>
        <div className="stock-grid">
          {stock.map((item) => (
            <div key={item.id} className="stock-item">
              <img src={item.image} alt={item.name} className="stock-image" />
              <h3 className="stock-name">{item.name}</h3>
              <p className="stock-price">{item.price}</p>
              <p className={item.available ? "stock-available" : "stock-unavailable"}>
                {item.available ? "Disponible" : "Agotado"}
              </p>
              {item.available && (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="stock-button"
                >
                  🛒 Comprar en WhatsApp
                </a>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Stock;
